module.exports = __webpack_public_path__ + "static/media/bad-2.92bff330.svg";